// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3r_bC","header":"MergedInvoice_header__3AUIk"};